export type CartCurrentBaseEvent = typeof CART_CURRENT_BASE_EVENT;

export const CART_CURRENT_BASE_EVENT = `cart:current`;

export const CART_CURRENT_EVENT = <const>{
	CATEGORIZE: `${CART_CURRENT_BASE_EVENT}:categorize`,
	CATEGORIZE_ADD: `${CART_CURRENT_BASE_EVENT}:categorize:add`,
	CATEGORIZE_MOVE: `${CART_CURRENT_BASE_EVENT}:categorize:move`,
	CATEGORIZE_REMOVE: `${CART_CURRENT_BASE_EVENT}:categorize:remove`,
	CREATE_PDF: `${CART_CURRENT_BASE_EVENT}:createPDF`,
	CREATE_PDF_SHARE_LINK: `${CART_CURRENT_BASE_EVENT}:createPDFShareLink`,
	CREATE_PDF_DOWNLOAD: `${CART_CURRENT_BASE_EVENT}:createPDFDownload`,
	CREATE_TMS_OBJECT_PACKAGE: `${CART_CURRENT_BASE_EVENT}:create:tmsObjectPackage`,
	DELETE: `${CART_CURRENT_BASE_EVENT}:delete:assets`,
	DOWNLOAD: `${CART_CURRENT_BASE_EVENT}:download`,
	EMPTY: `${CART_CURRENT_BASE_EVENT}:empty`,
	EDIT_ATTRIBUTES: `${CART_CURRENT_BASE_EVENT}:edit:attributes`,
	EXPORT_ATTRIBUTES: `${CART_CURRENT_BASE_EVENT}:export:attributes`,
	EXPORT_ATTRIBUTES_DOWNLOAD: `${CART_CURRENT_BASE_EVENT}:export:attributes:download`,
	EXPORT_ATTRIBUTES_SHARE_LINK: `${CART_CURRENT_BASE_EVENT}:export:attributes:shareLink`,
	FIND_REPLACE: `${CART_CURRENT_BASE_EVENT}:findReplace`,
	MANAGE_ARCHIVE: `${CART_CURRENT_BASE_EVENT}:manage:archive`,
	MANAGE_ARCHIVE_ARCHIVE: `${CART_CURRENT_BASE_EVENT}:manage:archive:archive`,
	MANAGE_ARCHIVE_UNARCHIVE: `${CART_CURRENT_BASE_EVENT}:manage:archive:unarchive`,
	MANAGE_EXPIRATION: `${CART_CURRENT_BASE_EVENT}:manage:expiration`,
	MANAGE_EXPIRATION_SET: `${CART_CURRENT_BASE_EVENT}:manage:expiration:set`,
	MANAGE_EXPIRATION_UNSET: `${CART_CURRENT_BASE_EVENT}:manage:expiration:unset`,
	MENU: `${CART_CURRENT_BASE_EVENT}:menu`,
	RELATIONSHIPS: `${CART_CURRENT_BASE_EVENT}:relationships`,
	RELATIONSHIPS_LINK: `${CART_CURRENT_BASE_EVENT}:relationships:link`,
	RELATIONSHIPS_DELINK: `${CART_CURRENT_BASE_EVENT}:relationships:unlink`,
	REPURPOSE: `${CART_CURRENT_BASE_EVENT}:repurpose`,
	RESYNC: `${CART_CURRENT_BASE_EVENT}:resync`,
	REVIEW: `${CART_CURRENT_BASE_EVENT}:review`,
	SAVE: `${CART_CURRENT_BASE_EVENT}:save`,
	VISIBILITY: `${CART_CURRENT_BASE_EVENT}:visibility`,
	VISIBILITY_HIDE: `${CART_CURRENT_BASE_EVENT}:visibility:hide`,
	VISIBILITY_SHOW: `${CART_CURRENT_BASE_EVENT}:visibility:show`,
};
